<template>
  <v-row no-gutters>
    <v-col cols="12" md="4">
      <v-row no-gutters class="mt-4 pl-4 pr-4">
        
        <v-col cols="12" md="12">
          <v-text-field
            label="Descripton"
            v-model="rating.description"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            label="Rating"
            v-model.number="rating.rating"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="text-right">
          <v-btn color="green" dark @click="clickSaveOrUpdate()">{{ saveOrupdate }}</v-btn>
        </v-col>
      </v-row>
    </v-col>
     <v-col cols="12" md="8" class="mt-3">
      <v-row no-gutters>
        
        <v-col cols="12" md="12">
          <v-simple-table
            :fixed-header="true"
            dense
            class="elevation-1 mb-2"
            height="85vh"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center white--text primary">No.</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Description</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Rating</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  
                  <th class="text-center white--text primary">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in ratingList"
                  :key="index"
                  @click="selectedOne = item"
                  :style="{
                    backgroundColor:
                      item.ratingId == selectedOne.ratingId
                        ? '#def3ff'
                        : 'transparent',
                  }"
                >
                  <td class="text-center" >{{ index + 1 }}</td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center" >{{ item.description }} </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">{{ item.rating }}</td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  

                  <td class="text-center" >
                    <span v-if="item.ratingId !=0">
                    <v-btn small icon color="green" @click="clickEdit(item)" >
                      <v-icon>edit</v-icon></v-btn
                    >
                    <v-btn small icon color="red" @click="clickDelete(item)" >
                      <v-icon>delete</v-icon></v-btn
                    >
                  </span>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-dialog
      v-model="dialogDelete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red white--text">
          Do you want to delete({{deleteRating.ratingId}})?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red"
            @click="clickOkDelete()"
            dark
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-col>
    
  </v-row>
</template>
<script>
import ratingService from "../service/RatingService";
export default {
  data: () => ({
    saveOrupdate:"SAVE",
    selectedOne: {},
    rating: { rating: 0},
    ratingList : [],
    deleteRating:{},
    dialogDelete:false
  }),
  props: {},
  mounted: function () {
    this.getSearch();
  },
  methods: {
     getSearch: function () {
      ratingService
        .getRating()
        .then((data) => {
          this.ratingList = data;
          this.saveOrupdate = "SAVE";
          this.rating.rating = 0;
          
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
    clickSaveOrUpdate:function(){
      if(this.saveOrupdate == "SAVE"){
      ratingService
        .addRating(this.rating)
        .then((data) => {
          this.getSearch();
          this.$swal({
              title: "Successful",
              text: "Successful!",
              type: "success",
              timer: 500,
            });
            
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
      }else{
        ratingService
        .updateRating(this.rating)
        .then((data) => {
          this.getSearch();
          this.$swal({
              title: "Successful",
              text: "Successful!",
              type: "success",
              timer: 500,
            });
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
      }
    },
    clickDelete:function(item){
        this.deleteRating = Object.assign({},item);
        this.dialogDelete = true;
    },
    clickEdit:function(item){
      this.rating = Object.assign({},item);
      this.saveOrupdate = "UPDATE";
    },
    clickOkDelete:function(){
      this.dialogDelete = false;
      ratingService
        .deleteRating(this.deleteRating)
        .then((data) => {
          this.getSearch();
          this.$swal({
              title: "Successful",
              text: "Successful!",
              type: "success",
              timer: 500,
            });
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
  },
  
  watch: {
    
  },
  components: {},
};
</script>
<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 2px !important;
}
</style>